class CartNoteBox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.textarea = this.querySelector('textarea');
    this.cartNoteUpdatedNotification = this.querySelector('[data-cart-note-updated]');

    this.handleSubmit = this.handleSubmit.bind(this);

    this.textarea.addEventListener('change', this.handleSubmit);
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener('click', this.handleSubmit);
  }

  handleSubmit() {
    const note = {note: this.textarea.value.toString()};

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(note)
    })
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error: ', error))

    this.showNote();
  }

  showNote() {
    this.cartNoteUpdatedNotification.dataset.cartNoteUpdated = 'true';
    setTimeout(() => {
      this.cartNoteUpdatedNotification.dataset.cartNoteUpdated = 'false';
    }, 3000)
  }
}

customElements.define('cart-note-box', CartNoteBox);
